// 重置浏览器样式
import boot from '$boot/boot';
import pageComponent from './index';
import DocumentTitlePlugin from '$common/utils/vue-plugin/document-title';
import TecalcMixin from '$common/utils/vue-plugin/mixins/recalc-mixin';
import ToolMixin from '$common/utils/vue-plugin/mixins/tool-mixin';
import DocumentMixin from '$common/utils/vue-plugin/mixins/document-mixin';
Vue.use(DocumentTitlePlugin)
try {
  //  将后端渲染的东西序列化成对象
  window.ssrConfig = JSON.parse(decodeURIComponent(window.ssrConfig));
} catch (err) {}
boot({
  Vue,
  pageComponent,
  before: config => Object.assign({}, config, {
    mixins: [TecalcMixin, ToolMixin, DocumentMixin]
  })
});